import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';
import { LocationListItem } from '../models/common.model';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService extends BaseHttpService {
  private _cacheService = inject(CacheService);

  getAllLocations(): Observable<LocationListItem[]> {
    return this._cacheService.cacheObservable(
      '/api/location',
      this.httpClient.get<LocationListItem[]>(`${this.baseApiUrl}/api/location`)
    );
  }

  getAllByCountry(countryUid: string): Observable<LocationListItem[]> {
    return this._cacheService.cacheObservable(
      `/api/location/byCountry/${countryUid}`,
      this.httpClient.get<LocationListItem[]>(`${this.baseApiUrl}/api/location/byCountry/${countryUid}`)
    );
  }

  getLocationByCodeOrUid(codeOrUid: string): Observable<LocationListItem> {
    return this.httpClient.get<LocationListItem>(`${this.baseApiUrl}/api/location/${codeOrUid}`);
  }

  search(searchString: string): Observable<LocationListItem[]> {
    return this.httpClient.get<LocationListItem[]>(`${this.baseApiUrl}/api/location?searchString=${searchString}`);
  }
}
